function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';
import styles from './CurrentSongRequestDescription.module.scss';
import { Anchor, Avatar, Badge, Text } from '@mantine/core';
import classNames from 'classnames';
function CurrentSongRequestDescription(_param) {
    var song = _param.song, className = _param.className, _param_isPlaying = _param.isPlaying, isPlaying = _param_isPlaying === void 0 ? false : _param_isPlaying, initialPlayerPosition = _param.playerPosition, _param_isCurrentSongRequestFromPlaylist = _param.isCurrentSongRequestFromPlaylist, isCurrentSongRequestFromPlaylist = _param_isCurrentSongRequestFromPlaylist === void 0 ? false : _param_isCurrentSongRequestFromPlaylist, props = _object_without_properties(_param, [
        "song",
        "className",
        "isPlaying",
        "playerPosition",
        "isCurrentSongRequestFromPlaylist"
    ]);
    var _React_useState = _sliced_to_array(React.useState(initialPlayerPosition), 2), position = _React_useState[0], setPosition = _React_useState[1];
    React.useEffect(function() {
        setPosition(initialPlayerPosition);
        if (!isPlaying || song == null) {
            return;
        }
        var interval = setInterval(function() {
            setPosition(function(prevPosition) {
                if (prevPosition >= song.track.duration) {
                    return song.track.duration;
                }
                return prevPosition + 1;
            });
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        initialPlayerPosition,
        isPlaying,
        song
    ]);
    if (song == null) {
        return /*#__PURE__*/ _jsx("div", _object_spread({
            className: styles.emptyDescription
        }, props));
    }
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: classNames(styles.description, className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.badgeContainer,
                children: [
                    /*#__PURE__*/ _jsx(Badge, {
                        variant: "light",
                        color: "textSecondary",
                        children: isPlaying ? /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "1vUhCw",
                            defaultMessage: "Now Playing"
                        }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "IpkirO",
                            defaultMessage: "Up Next"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        size: "sm",
                        className: styles.requestedBy,
                        children: !isCurrentSongRequestFromPlaylist && 'user' in song ? /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "nyAh/j",
                            defaultMessage: "Requested by {user}",
                            values: {
                                user: song.user.displayName
                            }
                        }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "aDLBuJ",
                            defaultMessage: "From Playlist"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Anchor, {
                href: song.track.url,
                className: styles.title,
                children: song.track.title
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.artistContainer,
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        size: "sm",
                        src: song.track.artistAvatarUrl,
                        radius: "full"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        children: song.track.artist
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        children: "•"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        children: dayjs.duration(song.track.duration - position, 'seconds').format('mm:ss')
                    })
                ]
            })
        ]
    }));
}
export default CurrentSongRequestDescription;
